<div>
  <div *ngFor="let tableSection of tableSections" class="CommonTable knownIssueTable">
    <div id="{{ tableSection.heading }}" [innerHTML]="tableSection.body | mdToHtml"></div>
    <div class="body-table knownIssueTable" *ngIf="tableSection.table" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>
